import { createSlice } from "@reduxjs/toolkit";
import { SearchFieldState } from "../types";

const initialState: SearchFieldState = {
  awaitingAskResponse: false,
  globalSearchText: "",
};

const searchFieldSlice = createSlice({
  name: "searchField",
  initialState,
  reducers: {
    setAwaitingAskResponse(state, action) {
      state.awaitingAskResponse = action.payload;
    },
    setGlobalSearchText(state, action) {
      state.globalSearchText = action.payload;
    },
  },
});

export default searchFieldSlice.reducer;
export const searchFieldActions = searchFieldSlice.actions;
